import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["id", "data-cy"];
var _hoisted_3 = {
  style: {
    "overflow-wrap": "anywhere"
  }
};
var _hoisted_4 = ["src", "alt"];
var _hoisted_5 = ["href"];
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = {
  "class": "d-flex tw-items-center"
};
var _hoisted_8 = ["data-id"];
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["data-id"];
var _hoisted_12 = ["innerHTML"];
import { useCommonVars } from "@wkComposables/useCommonVars";
import { useShowPhone } from "@wkComposables/useShowPhone";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { MailIcon } from "@vueEntry/SvgIcons/MailIcon";
import { PhoneIcon } from "@vueEntry/SvgIcons/PhoneIcon";
import { ref, onBeforeMount } from "vue";
import { useMetadataStore } from "@wkWebSrc/js/store";
export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantCard',
  props: {
    realEstateId: {},
    isCardRow: {
      type: Boolean,
      "default": true
    },
    consultant: {},
    placeId: {},
    typologyName: {},
    productPrice: {},
    onlyPhone: {
      type: Boolean,
      "default": false
    },
    labels: {}
  },
  emits: ["onPressedContactBtn"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var cardTitle = ref("");
    var isTop = ref(false);
    var isSuggested = ref(false);
    var mdStore = useMetadataStore();
    var _useCommonVars = useCommonVars(),
      wkLabels = _useCommonVars.wkLabels;
    var _useShowPhone = useShowPhone(),
      showPhone = _useShowPhone.showPhone;
    onBeforeMount(function () {
      if (props.consultant.top_flag) {
        isTop.value = true;
        cardTitle.value = props.labels.top;
      }
      if (props.consultant.extra_flag) {
        isSuggested.value = true;
        cardTitle.value = props.labels.suggested;
      }
    });
    var handleBtnClick = function handleBtnClick(agencyData) {
      emits("onPressedContactBtn", agencyData);
    };
    var redirectOnConsultant = function redirectOnConsultant() {
      location.href = props.consultant.consultant_agency.url;
    };
    var call = function call(phone) {
      var _a;
      window.location.href = (_a = "tel:".concat(phone)) !== null && _a !== void 0 ? _a : "#";
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass([_unref(isSuggested) ? 'tw-bg-w-primary tw-border-w-primary tw-border-2' : _unref(isTop) ? 'tw-bg-yellow-600 tw-border-yellow-600 tw-border-2' : '', "tw-rounded"])
      }, [_unref(cardTitle) ? (_openBlock(), _createElementBlock("h3", {
        key: 0,
        "class": "tw-text-white tw-text tw-font-semibold tw-px-20px tw-py-5px",
        innerHTML: _unref(cardTitle)
      }, null, 8 /* PROPS */, _hoisted_1)) : _createCommentVNode("v-if", true), _createElementVNode("div", {
        id: 'consultant-card-' + _ctx.consultant.consultant_user_id,
        "data-cy": 'consultant-card-datacy-' + _ctx.consultant.consultant_agency.id,
        "class": _normalizeClass(["tw-p-20px tw-border tw-flex tw-gap-10px tw-bg-white tw-border-solid tw-border-w-lavender tw-rounded tw-justify-between", _ctx.isCardRow ? 'tw-flex-row' : 'tw-flex-col'])
      }, [_createCommentVNode(" CONSULTANT IMG "), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        "class": "tw-object-contain tw-h-[34px] tw-cursor-pointer tw-mb-10px",
        src: "/rest/agency/getAgencyImageByAgencyID/".concat(_ctx.consultant.consultant_agency.id, "/2"),
        alt: _ctx.consultant.consultant_agency.name + ' - ' + _unref(wkLabels).photo + '- 1',
        onClick: redirectOnConsultant
      }, null, 8 /* PROPS */, _hoisted_4), _createCommentVNode(" CONSULTANT LINK "), _createElementVNode("a", {
        itemprop: "name",
        "class": "tw-text-left tw-block tw-text-16 sm:tw-text tw-font-semibold",
        href: _ctx.consultant.consultant_agency.url
      }, [_createElementVNode("span", {
        innerHTML: _ctx.consultant.consultant_agency.name
      }, null, 8 /* PROPS */, _hoisted_6)], 8 /* PROPS */, _hoisted_5)]), _createCommentVNode(" CONSULTANT BTNS "), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        "class": _normalizeClass(["tw-flex", _ctx.isCardRow ? 'tw-flex-col tw-gap-y-10px' : 'tw-flex-row tw-gap-x-10px'])
      }, [_createCommentVNode(" show phone btn "), !_ctx.onlyPhone ? (_openBlock(), _createBlock(BaseButton, {
        key: 0,
        "data-cy": "show-phone-btn-consultant-".concat(_ctx.consultant.consultant_agency.id),
        "btn-class": "tw-btn-w-primary tw-btn-outline tw-btn-sm tw-flex !tw-w-full tw-items-center tw-justify-center",
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          return _unref(showPhone)({
            agencyId: _ctx.consultant.consultant_agency.id,
            agencyName: _ctx.consultant.consultant_agency.name,
            subscriptionType: _ctx.consultant.consultant_agency.subscriptionType,
            id: props.realEstateId,
            placeID: _ctx.placeId,
            price: _ctx.productPrice,
            auction: true,
            typologyName: _ctx.typologyName,
            userTypologyId: _ctx.consultant.consultant_agency.userTypologyId
          }, "".concat(_unref(mdStore).pageName, " - Card Consulente"), _ctx.consultant.consultant_agency.displayPhone);
        }, ["prevent", "stop"]))
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_unref(PhoneIcon), {
            width: 16,
            height: 16,
            "class": "tw-mr-5px tw-inline-block"
          }), _createElementVNode("span", {
            "data-id": "phone-".concat(_ctx.consultant.consultant_agency.id)
          }, [_createElementVNode("span", {
            innerHTML: _unref(wkLabels).phone
          }, null, 8 /* PROPS */, _hoisted_9)], 8 /* PROPS */, _hoisted_8)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data-cy"])) : _createCommentVNode("v-if", true), _createCommentVNode(" Contact btn "), !_ctx.onlyPhone ? (_openBlock(), _createBlock(BaseButton, {
        key: 1,
        "data-cy": "open-contact-consultant-modal-btn-".concat(_ctx.consultant.consultant_agency.id),
        "btn-class": "tw-btn-w-primary tw-btn-outline tw-btn-sm tw-flex !tw-w-full tw-items-center tw-justify-center",
        onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
          return handleBtnClick(_ctx.consultant.consultant_agency);
        }, ["prevent", "stop"]))
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_unref(MailIcon), {
            width: 17,
            height: 17,
            "class": "tw-mr-5px tw-inline-block"
          }), _createElementVNode("span", {
            "class": "tw-inline-block tw-font-semibold tw-ml-5px",
            innerHTML: _unref(wkLabels).contactBtn
          }, null, 8 /* PROPS */, _hoisted_10)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data-cy"])) : _createCommentVNode("v-if", true), _createCommentVNode(" PHONE BTN - show phone "), _ctx.onlyPhone ? (_openBlock(), _createBlock(BaseButton, {
        key: 2,
        "data-cy": "open-contact-consultant-modal-btn-".concat(_ctx.consultant.consultant_agency.id),
        "btn-class": "tw-btn-w-primary tw-btn-outline tw-btn-sm tw-flex !tw-w-full tw-items-center tw-justify-center tw-max-w-[50%]"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_unref(PhoneIcon), {
            width: 16,
            height: 16,
            "class": "tw-mr-5px tw-inline-block"
          }), _createElementVNode("span", {
            "data-id": "phone-".concat(_ctx.consultant.consultant_agency.id)
          }, [_createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return call(_ctx.consultant.consultant_agency.displayPhone);
            }),
            innerHTML: _ctx.consultant.consultant_agency.displayPhone
          }, null, 8 /* PROPS */, _hoisted_12)], 8 /* PROPS */, _hoisted_11)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data-cy"])) : _createCommentVNode("v-if", true)], 2 /* CLASS */)])], 10 /* CLASS, PROPS */, _hoisted_2)], 2 /* CLASS */);
    };
  }
});